import React from 'react';

import Auto1 from '../../imgs/Auto-1.png';
import think from '../../imgs/think.png';

export default class Auto2 extends React.Component {
  render() {
    return (
      <div className='typography-container'>
    <h1>
        Физические явления, ограничивающие скорость движения автомобиля
    </h1>
<p align="center">
    <img className='responsive-img' src={Auto1}/>
</p>
<p>
    К силам, действующим на автомобиль, относятся: сила тяжести, силы
    взаимодействия колес с дорогой, силы взаимодействия с воздухом (рис 1).
    Одни из этих сил направлены по движению автомобиля и называются движущими,
    другие - против движения и называются силами сопротивления.
</p>
<p>
    Движущей силой, всегда направленной по направлению движения на тяговом
    режиме для одиночного автомобиля, является суммарная продольная реакция на
    ведущих колесах, возникающая в результате того, что к этим колесам
    подводится момент от двигателя через трансмиссию. Этот момент преобразуется
в результате взаимодействия ведущих колес с дорогой в движущую силу.    <strong></strong>
</p>
<p>
    Силы сопротивления воздуха и продольные реакции на ведомых колесах всегда
    направлены против движения. Составляющая силы тяжести, параллельная дороге,
    может быть направлена либо по движению, либо
    против движения, в зависимости от того, движется ли автомобиль на подъем
    или под уклон.
</p>
<p>
    <h1>Подумай: </h1>
</p>
<p>
    Как можно уменьшить силы сопротивления движению?
</p>
    <img className='responsive-img' src={think}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/Auto-2.js